module.exports = __webpack_public_path__ + "img/EYE.e1b22442.svg";